import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { SkipNavigation } from "../components/SkipNavigation";
import { AuthNavigationHeader } from "../pages/auth/components/AuthNavigationHeader";
import { OnboardingRedirect } from "../components/OnboardingRedirect";

const NEW_LAYOUT_PATHS = [
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/verify-email",
];
const BACK_TO_LOGIN_PATHS = ["/forgot-password", "/reset-password", "/verify-email"];
const HIDE_FOOTER_PATHS = ["/settings"];

const AppLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isNewLayoutRoute = NEW_LAYOUT_PATHS.includes(pathname);
  const hideFooter = HIDE_FOOTER_PATHS.includes(pathname);
  const shouldBackToLogin = BACK_TO_LOGIN_PATHS.includes(pathname);

  const handleAuthBackClick = () => {
    if (shouldBackToLogin) {
      navigate("/login");
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const renderNewLayout = () => (
    <div className="min-h-screen flex flex-col bg-[var(--color-bg-surface)]">
      <OnboardingRedirect />
      <SkipNavigation
        links={[
          { href: "#main-content", label: "Skip to main content" },
          { href: "#main-navigation", label: "Skip to navigation" },
        ]}
      />
      <AuthNavigationHeader onBackClick={handleAuthBackClick} backToLogin={shouldBackToLogin} />
      <main id="main-content" role="main" className="flex-1">
        <Outlet />
      </main>
    </div>
  );

  const renderDefaultLayout = () => (
    <div className="min-h-screen flex flex-col bg-[var(--color-bg-surface)]">
      <OnboardingRedirect />
      <SkipNavigation
        links={[
          { href: "#main-content", label: "Skip to main content" },
          { href: "#main-navigation", label: "Skip to navigation" },
        ]}
      />
      <Header />
      <main id="main-content" role="main" className="flex-1">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </div>
  );

  return isNewLayoutRoute ? renderNewLayout() : renderDefaultLayout();
};

export default AppLayout;
